/**
 * Global Mobile Bottom Bar
 *
 * Detay sayfaları kendi <MobileReservationBar>'larını render eder (form sheet ile).
 * Diğer tüm sayfalarda bu component sticky bottom CTA olarak görünür ve
 * tıklamada /genel-plan'a yönlendirir.
 *
 * App.tsx'in root'una koyulur, route'a göre kendi kendini gizler/gösterir.
 */
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { pathWithLang, type Lang } from '../i18n'
import i18n from '../i18n'
import './GlobalMobileBar.css'

/** Bu route'larda zaten sayfa-içi rezervasyon bar'ı (form sheet) var, global'i render etme.
 *  Yalnızca detay sayfaları kendi MobileReservationBar'larını gösterir;
 *  suite-villas / garden-villas seçim sayfaları global bar'ı kullanır. */
const SUPPRESS_PATHS = [
  /^\/(?:en|de|ru|ar|fr|zh)?\/?villa\/[^/]+$/,
  /^\/(?:en|de|ru|ar|fr|zh)?\/?tesis\/[^/]+$/,
  /^\/(?:en|de|ru|ar|fr|zh)?\/?restaurant\/?$/,
]

const GlobalMobileBar = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const currentLang = (i18n.language?.slice(0, 2) || 'tr') as Lang

  const shouldSuppress = SUPPRESS_PATHS.some(re => re.test(location.pathname))

  // Bar görünür sayfalarda body'ye class ekle ki CSS bottom padding'i aktif olsun.
  // Detay sayfalarında bar render edilmez + class da silinir (sayfa kendi
  // .villa-detail-page main { padding-bottom: 96px } ile zaten boşluk veriyor).
  useEffect(() => {
    if (shouldSuppress) {
      document.body.classList.remove('has-global-mobile-bar')
    } else {
      document.body.classList.add('has-global-mobile-bar')
    }
    return () => {
      document.body.classList.remove('has-global-mobile-bar')
    }
  }, [shouldSuppress])

  if (shouldSuppress) return null

  const handleReserve = () => {
    navigate(pathWithLang('/genel-plan', currentLang))
  }

  return null // Rezervasyon bar geçici kapalı (owner) — sonra açılacak

  return (
    <div className="global-mobile-bar" role="region" aria-label={t('common.reservation')}>
      <div className="gmb-info">
        <span className="gmb-brand">{t('common.brandName')}</span>
        <span className="gmb-tagline">{t('common.brandTagline')}</span>
      </div>
      <button
        type="button"
        className="gmb-cta"
        onClick={handleReserve}
        aria-label={t('common.reservation')}
      >
        {t('common.reservation')}
        <span aria-hidden="true" className="gmb-cta-arrow">→</span>
      </button>
    </div>
  )
}

export default GlobalMobileBar
